function formatCurrency(value) {
  let locale = 'de';

  if (
    this.context
    && this.context.config
    && this.context.config.language
  ) {
    locale = this.context.config.language;
  }

  value = parseFloat(value, 10);

  let formatter;
  try {
    formatter = new Intl.NumberFormat(locale, {
      style: 'decimal',
      useGrouping: true,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  } catch (e) {
    formatter = {
      format: (value) => value,
    };
  }

  return formatter.format(parseFloat(value));
}

module.exports = formatCurrency;



// WEBPACK FOOTER //
// ./src/libs/twig/format_currency/index.js